
import { defineComponent, type PropType } from 'vue'
import { IdfIcon, IdfImage } from '@invivodf/ui-kit'

/**
 * Remplacement local d'`IdfQuotaCard` (composant hébergé par @b2ag/design-system malgré son
 * préfixe `Idf`). La vignette passe d'`AdnImage` à `IdfImage`, les icônes de mode de livraison
 * et le chevron de navigation de la police d'icônes du design system à `IdfIcon`.
 */
export default defineComponent({
  name: 'PQuotaCard',
  components: { IdfIcon, IdfImage },
  props: {
    thumbnail: { type: String, default: '' },
    variantName: { type: String, required: true },
    offerValidityEndDate: { type: String, default: '' },
    offerShippingDates: { type: String, default: '' },
    shippingIcons: { type: Array as PropType<string[]>, default: () => [] },
    offerSegments: { type: String, default: '' },
  },
})
